module.exports = __webpack_public_path__ + "public/SiteIcons/docsVerifi.png?99f8f93f";